export const SHOW_CLIENT_ID = 'SHOW_CLIENT_ID'


export const callClientId = (clientId: any) => async(dispatch : any) => {
  dispatch({
    type: SHOW_CLIENT_ID,
    id: clientId
  })
}